export default __webpack_public_path__ + "static/media/muffito_logo.6b273387.png";